import {useCallback, useEffect, useMemo, useState} from 'react';
import {useRequest} from 'ahooks';
import {getRankPromotion} from '@/pages/promotions/service';
import {useFocusEffect} from '@react-navigation/native';
import globalStore from '@services/global.state';

export const useShowLeaderboardRect = () => {
  const [token, setToken] = useState<string | null>(null);
  const [reload, setReload] = useState(0);
  const {data: rankPromotion} = useRequest(() => getRankPromotion(), {
    refreshDeps: [token, reload],
    ready: !!token,
  });
  const leaderTypes = useMemo(() => {
    const obj = {
      NEW_USER_RANK_ACTIVITY: false,
      FISSION_RANK_ACTIVITY: false,
      OLD_USER_RANK_ACTIVITY: false,
      PK_RANK_ACTIVITY: false,
    };

    // 如果 token 为空，直接返回全 false
    if (!token) {
      return obj;
    }

    rankPromotion?.forEach((item: any) => {
      obj[item.activityCode as keyof typeof obj] = true;
    });
    return obj;
  }, [rankPromotion, token]);
  useFocusEffect(
    useCallback(() => {
      setReload(prev => prev + 1);
    }, []),
  );
  useEffect(() => {
    const sub = globalStore.tokenSubject.subscribe(newToken => {
      setToken(newToken);
    });
    return () => {
      sub.unsubscribe();
    };
  }, []);
  return leaderTypes;
};
